import type { BoardState } from '../types';
import type { TileColor } from '../TileColor';
import { filterUnique } from '../../../utils/array-utils';

export function extractBoardStateColors(board: BoardState): TileColor[] {
  const boardColors = board.stacks.map((stackState) => stackState.tiles).flat(2);
  return filterUnique(boardColors).sort();
}
